"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getMaxFavoriteSuggestionCounts_1 = require("./getMaxFavoriteSuggestionCounts");
var isInFavorites_1 = require("owa-mail-favorites-store/lib/selectors/isInFavorites");
var getFoldersForMoveTo_1 = require("owa-mail-store/lib/utils/getFoldersForMoveTo");
function getFavoriteFolderSuggestions(findText) {
    var maxFolderSuggestions = getMaxFavoriteSuggestionCounts_1.default().folder;
    // Find top matching folders not already in favorites
    var folders = getFoldersForMoveTo_1.default(findText, maxFolderSuggestions, function (folderId) { return !isInFavorites_1.isFolderInFavorites(folderId); }).folders; /* customFilter */
    var items = folders.map(function (folder) {
        var folderDisplayName = folder.displayName;
        return {
            id: folder.folderId,
            data: folderDisplayName,
            type: 0 /* Folder */,
            relevance: 0 /* Relevance scores will be supplied by providers in the future */,
        };
    });
    return items;
}
exports.default = getFavoriteFolderSuggestions;
//# sourceMappingURL=getFavoriteFolderSuggestions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-find-favorites/lib/actions/helpers/getFavoriteFolderSuggestions.js
// module id = 6277
// module chunks = 68